import { array, intersect, partial, struct } from 'io-ts/Decoder';

import { Role } from './Role';
import { ScopeFilter } from './ScopeFilter';
import { Id as UserGroupId } from './user-group/Id';

export const Scope = intersect(
	intersect(
		struct({
			userGroup: UserGroupId,
		})
	)(
		partial({
			roles: array(Role),
		})
	)
)(ScopeFilter);
